'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is an onward ticket?',
      answer: 'An onward ticket is a verifiable flight reservation with a valid PNR (Passenger Name Record) that proves you have plans to leave a country. It\'s commonly required for visa applications, embassy interviews, and airline check-in when entering countries on a one-way ticket.'
    },
    {
      question: 'Is this a real flight booking?',
      answer: 'Yes! We create a real flight reservation in the airline\'s booking system with a valid PNR that can be verified by embassies, consulates, and airlines. The reservation is active for the duration of your selected plan (48 hours, 7 days, or 14 days).'
    },
    {
      question: 'Will embassies accept this ticket?',
      answer: 'Absolutely. Our onward tickets are genuine flight reservations with verifiable PNRs that are accepted by embassies and consulates worldwide. Thousands of travelers have successfully used our service for visa applications.'
    },
    {
      question: 'How quickly will I receive my ticket?',
      answer: 'Your onward ticket will be delivered to your email within 5-30 minutes after payment confirmation. In most cases, you\'ll receive it within 10 minutes.'
    },
    {
      question: 'What if my visa is rejected?',
      answer: 'We offer a 100% money-back guarantee if your visa application is rejected. Simply provide proof of rejection, and we\'ll process your refund within 5-7 business days.'
    },
    {
      question: 'Can I change the flight dates?',
      answer: 'Yes! Standard plan includes 1 free date change, and Premium plan includes unlimited date changes. Simply contact our support team with your new travel dates.'
    },
    {
      question: 'What information do I need to provide?',
      answer: 'You\'ll need to provide passenger details (name as per passport, date of birth, passport number), flight information (departure city, destination, travel dates), and contact information (email and phone number).'
    },
    {
      question: 'Is my payment secure?',
      answer: 'Yes, we use industry-standard encryption and secure payment gateways. Your payment information is never stored on our servers, and all transactions are fully encrypted.'
    }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-black text-gray-900 mb-2">Frequently Asked Questions</h2>
        <p className="text-gray-600">Everything you need to know about onward tickets</p>
      </div>
      <div className="space-y-4 max-w-3xl mx-auto">
        {faqs?.map((faq, index) => (
          <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="font-bold text-gray-900 pr-4">{faq?.question}</span>
              <Icon
                name="ChevronDownIcon"
                size={20}
                className={`text-gray-500 flex-shrink-0 transition-transform duration-200 ${
                  openIndex === index ? 'transform rotate-180' : ''
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4 text-gray-600">
                {faq?.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}